import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';

const NavbarMain = () => {
    return (
        <>
            <Navbar sticky="top" expand="lg" className="rapidgoo-navbar">
                <Container>
                    <Navbar.Brand as={Link} to="/" className="brand-text">
                        <span className="black">RapidGoo</span>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ms-auto">
                            <Nav.Link as={Link} to="/home">Home</Nav.Link>
                            <NavDropdown title="Services" id="services-dropdown">
                                <NavDropdown.Header>Business Services</NavDropdown.Header>
                                <NavDropdown.Item as={Link} to="/services/business-registration">Business Registration</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/services/vat-filing">VAT Filing</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/services/bookkeeping">Bookkeeping</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/services/financial-consulting">Financial Consulting</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Header>IT & Digital</NavDropdown.Header>
                                <NavDropdown.Item as={Link} to="/services/web-development">Web Development</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/services/mobile-development">Mobile Apps</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/services/software-development">Software Development</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/services/digital-solutions">Digital Solutions</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Header>Infrastructure & Security</NavDropdown.Header>
                                <NavDropdown.Item as={Link} to="/services/networking">Networking</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/services/bms">Building Management</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/services/cybersecurity">Cybersecurity</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/services/it-consulting">IT Consulting</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Header>AI & Machine Learning</NavDropdown.Header>
                                <NavDropdown.Item as={Link} to="/services/ai-chatbot">AI Chatbots</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/services/multi-agent-ai">Multi-Agent AI</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/services/machine-learning">Machine Learning</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/services/computer-vision">Computer Vision</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/services/ai-search">AI Search</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/services/ai-automation">AI Automation</NavDropdown.Item>
                            </NavDropdown>
                            <NavDropdown title="Products" id="products-dropdown">
                                <NavDropdown.Item as={Link} to="/xivohr">
                                    <strong>XivoHR</strong>
                                    <small className="d-block text-muted">Smart Payroll & HR Platform</small>
                                </NavDropdown.Item>
                            </NavDropdown>
                            <Nav.Link as={Link} to="/about">About</Nav.Link>
                            <Nav.Link as={Link} to="/contact">Contact</Nav.Link>
                            <Nav.Link
                                as={Link}
                                to="/contact?demo=xivohr"
                                className="nav-cta-btn"
                            >
                                Get a Custom Quote
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    );
};

export default NavbarMain;
